const toggleIndividualData = function () {
  const individualCheck = $('.contacts-form #contact_contact_type_individual').is(':checked');
  $('.contacts-form .individual-data').toggleClass('d-none', !individualCheck);
  $('.contacts-form #contact_job_position').prop('disabled', !individualCheck);
  $('.contacts-form #contact_parent_id').prop('disabled', !individualCheck);
};

document.addEventListener('turbolinks:load', function () {
  toggleIndividualData();
  $('.contacts-form #contact_contact_type_individual').on('change', toggleIndividualData);
  $('.contacts-form #contact_contact_type_company').on('change', toggleIndividualData);
});
